module.exports = __webpack_public_path__ + "img/clockwise.ea9ca639.svg";